import { Module } from 'vuex'

import { GetSourceCodeByJudgeIdUseCase } from '@/application/sourceCode/getSourceCodeByJudgeIdUseCase'
import { SourceCodeRepository } from '@/domain/repositories/sourceCode/sourceCodeRepository'

interface ModelAnswerSourceCodeState {
  modelAnswerSourceCodeList: { [judgeId: number]: string }
  loading: boolean
  error: Error | null
}

export const modelAnswerSourceCodeModule = (
  sourceCodeRepository: SourceCodeRepository
): Module<ModelAnswerSourceCodeState, any> => {
  const getSourceCodeByJudgeIdUseCase = new GetSourceCodeByJudgeIdUseCase(sourceCodeRepository)

  return {
    namespaced: true,
    state: {
      modelAnswerSourceCodeList: {},
      loading: false,
      error: null
    },
    mutations: {
      setModelAnswerSourceCodeList(state, { list }: { list: { [judgeId: number]: string } }) {
        state.modelAnswerSourceCodeList = list
      },
      setModelAnswerSourceCodeListItem(state, { judgeId, item }: { judgeId: number; item: string }) {
        state.modelAnswerSourceCodeList[judgeId] = item
      },
      setLoading(state, loading: boolean) {
        state.loading = loading
      },
      setError(state, error: Error | null) {
        state.error = error
      }
    },
    actions: {
      async fetchModelAnswerSourceCodeList({ state, commit }, { judgeId }: { judgeId: number }) {
        commit('setLoading', true)
        commit('setError', null)
        try {
          const item = await getSourceCodeByJudgeIdUseCase.getSourceCodeByJudgeId(judgeId)
          commit('setModelAnswerSourceCodeListItem', { judgeId, item })
        } catch (error) {
          commit('setError', error)
        } finally {
          commit('setLoading', false)
        }
      }
    },
    getters: {
      modelAnswerSourceCodeList: state => state.modelAnswerSourceCodeList,
      loading: state => state.loading,
      error: state => state.error
    }
  }
}
